<!-- -->
<template>
  <el-dialog title="赠送优惠卷" v-model="visible" width="1240px">
    <page-request ref="table" url="/api/mgr/business/card/discount/list" :table-header="tableHeader" :expend="expend"  :hide-op="true">
    </page-request>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="visible=false">取消</el-button>
            <el-button type="primary" @click="doSelect()">选择</el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
import Page from "../../components/base/page";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";
export default {
  name: "send-discount",
  components: {BButton, PageRequest, TButton, Page},
  data() {
    return {
      visible:false,
      loading:false,
      tableHeader: [
        {type: "selection", label: ""},
        {prop: "name", label: "名称",minWidth:200},
        {label: "类型",renderDraw:row=>{
            return ['优惠券','折扣券','租赁券'][row['cardType']];
          },width:100},
        {label: "门店类型",renderDraw:row=>{
            return ['实体店','洗消店'][row['storeType']];
          },width:100},
        {label: "领券中心展示",renderDraw:row=>{
            return ['否','是'][row['isIndex']];
          },width: 120},
        {prop: "count", label: "发放量",width: 100},
        {prop: "receiveCount", label: "已领取",width: 100},
        {prop: "useNum", label: "已使用",width: 100},
        {label: "面额",renderDraw:row=>{
            return row.money+['元','折','天'][row.cardType];
          },width: 100},
        {label: "活动时间",renderDraw:row=>{
            return row.actTimeType==1?"长期有效":(row.startTime+"-"+row.endTime);
          },width: 180},
        {label: "使用条件",renderDraw:row=>{
            if(row.cardType==2){
              return `满${row.fullMoney}天可用${['',',指定商品',',指定门店'][row.goodsType]}`;
            }
            return `满${row.fullMoney}元可用${['',',指定商品',',指定门店'][row.goodsType]}`;
          },width: 200},
        {label: "状态",renderDraw:row=>{
            return ['待启动','进行中','已结束'][row['status']];
          },width: 100},
      ],
      expend: [
        {label: "名称", prop: "name"},
        {label: "门店类型", prop: "storeType",type:"select",options:[{"label":"实体店","value":"0"},{"label":"洗消店","value":"1"}]},
        {label: "状态", prop: "status",type:"select",options:[{"label":"待启动","value":"0"},{"label":"进行中","value":"1"},{"label":"已结束","value":"2"}]},
        {label: "有效期", start: "startTime", end: "endTime", type: "daterange"}
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doSelect(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        this.visible =false;
        this.$emit('send',list);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    },
    show(){
      this.visible =true;
    }
  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>

</style>
